import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
export const getEmployeesWorkloadReport = ({
    employeeId,
    departmentId,
    teamRoleId,
    clientType,
    includeInactive = false,
}) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const params = {
                employeeId,
                departmentId,
                teamRoleId,
                includeInactive: Boolean(includeInactive),
                ...(clientType === 1 || clientType === 2 ? { clientType } : {}),
            };
            const response = await axios.get(
                `${FIRMFLOWURL}api/Analytics/employeeWorkloadReport`,
                {
                    headers: { Authorization: token },
                    params,
                },
            );
            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.message });
        }
    });
};
